var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loader"},[_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"container-inner"},[_c('img',{attrs:{"src":require("@/assets/img/small_logo.png")}})])]),_c('canvas',{attrs:{"id":"background-canvas"}})])
}]

export { render, staticRenderFns }